import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';

const Navigation = ({ onOpenEmailModal }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Features', href: '#features' },
    { name: 'Academy', href: '#academy' },
    { name: 'Pricing', href: '#pricing' },
    { name: 'Security', href: '#security' },
  ];

  const handleDownloadClick = (e) => {
    e.preventDefault();
    onOpenEmailModal?.();
  };

  return (
    <nav
      data-testid="main-navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[#0B1F17]/90 backdrop-blur-xl shadow-lg border-b border-[#D4AF37]/10'
          : 'bg-transparent'
      }`}
    >
      <div className="container-custom">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="/"
            data-testid="nav-logo"
            className="flex items-center gap-2 font-heading text-2xl font-bold text-[#FAFAF7] hover:text-[#D4AF37] transition-colors"
          >
            Findell <span className="text-xl">🌿</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                data-testid={`nav-${link.name.toLowerCase()}-link`}
                className="font-body text-sm font-medium text-[#FAFAF7]/70 hover:text-[#D4AF37] transition-colors duration-300"
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href="#download"
              data-testid="nav-download-button"
              className="btn-heritage py-3 px-6 text-sm"
            >
              Download Free
            </a>
          </div>

          {/* Mobile Menu */}
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
            <SheetTrigger asChild>
              <button
                data-testid="mobile-menu-button"
                className="md:hidden p-2 text-[#FAFAF7]"
                aria-label="Open menu"
              >
                <Menu className="w-6 h-6" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] bg-[#FAFAF7] p-6">
              <div className="flex flex-col gap-6 mt-8">
                {navLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.href}
                    data-testid={`mobile-nav-${link.name.toLowerCase()}-link`}
                    onClick={() => setMobileMenuOpen(false)}
                    className="font-body text-lg font-medium text-[#2D2D2D] hover:text-[#D4AF37] transition-colors"
                  >
                    {link.name}
                  </a>
                ))}
                <hr className="border-[#1B4332]/10" />
                <a
                  href="#download"
                  data-testid="mobile-download-button"
                  className="btn-primary py-3 px-6 text-center"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Download Free
                </a>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
